import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

import { ApiSyllabusBook } from "../../config/setupsyllabus/ApiSetupBook";
import { GetLanguageString } from "../../helper/Components";
import { GetSelectedLanguage } from "../../helper/Method";
import CourseAttendeesSelectUnit from "../courses/CourseAttendeesSelectUnit";

const STATUSES = [
  { value: "all", key: "nisab_report_status_all" },
  { value: "completed", key: "nisab_report_status_completed" },
  { value: "notcompleted", key: "nisab_report_status_not_completed" },
];

const SearchRafiqWiseNisabReport = ({ filter, setFilter, onSearch }) => {
  const isUrdu = GetSelectedLanguage() !== "en";
  const { t } = useTranslation();
  const [syllabusOptions, setSyllabusOptions] = useState([]);

  useEffect(() => {
    ApiSyllabusBook()
      .GetSyllabusesSelectList()
      .then((res) => {
        setSyllabusOptions(res.data);
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <CourseAttendeesSelectUnit
        unitId={filter.unit.value}
        setValues={(values) => setFilter((prev) => ({ ...prev, unit: values.unit }))}
        values={filter}
      />
      <FormGroup check className="mb-3">
        <Label check>
          <Input
            type="checkbox"
            checked={filter.isSubUnits}
            onChange={(e) => setFilter((prev) => ({ ...prev, isSubUnits: e.target.checked }))}
          />
          <GetLanguageString props="member_search_member_sub_unit" />
        </Label>
      </FormGroup>
      <Row>
        <Col md="4">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="nisab_report_syllabus" />
            </Label>
            <Select
              isMulti
              options={syllabusOptions}
              value={filter.syllabi}
              onChange={(syllabi) => setFilter((prev) => ({ ...prev, syllabi: syllabi || [] }))}
              className={`basic-multi-select ${isUrdu ? "ur" : ""}`}
              classNamePrefix="select"
              closeMenuOnSelect={false}
              formatOptionLabel={(option) => <span className="ur">{option.label}</span>}
              placeholder={t("nisab_report_all_syllabi")}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="nisab_report_status" />
            </Label>
            <Input
              type="select"
              value={filter.status}
              onChange={(e) => setFilter((prev) => ({ ...prev, status: e.target.value }))}
            >
              {STATUSES.map((s) => (
                <option key={s.value} value={s.value}>
                  {t(s.key)}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="nisab_report_search_label" />
            </Label>
            <Input
              type="text"
              value={filter.search}
              placeholder={t("nisab_report_search_placeholder")}
              onChange={(e) => setFilter((prev) => ({ ...prev, search: e.target.value }))}
              onKeyDown={(e) => e.key === "Enter" && onSearch()}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <button type="button" className="nisab-btn" onClick={onSearch} >
            <GetLanguageString props="common_view_report" />
          </button>
        </Col>
      </Row>
    </>
  );
};

export default SearchRafiqWiseNisabReport;
